export default {
  scanTable: {
    zh: '扫描表',
    en: ' Scan Table',
  },
  createTable: {
    zh: '创建表',
    en: 'Create Scan Table',
  },
  lookupTable: {
    zh: '查询表',
    en: 'Lookup Table',
  },
  createLookupTable: {
    zh: '创建查询表',
    en: 'Create Lookup Table',
  },
  viewTable: {
    zh: '查看表',
    en: 'View table',
  },
  tableName: {
    zh: '表名称',
    en: 'Table Name',
  },
  tableType: {
    zh: '表类型',
    en: 'Table Type',
  },
  isSchemaType: {
    zh: '是否为带结构的表',
    en: 'Whether the schema table',
  },
  schemaTip: {
    zh: `自定义表字段结构，\n例如对应 SQL 语句中的：\n(
        USERID BIGINT,
        FIRST_NAME STRING,
        LAST_NAME STRING,
        NICKNAMES ARRAY(STRING),
        Gender BOOLEAN,
        ADDRESS STRUCT(
            STREET_NAME STRING,
            NUMBER BIGINT
        ),
    )`,
    en: `Custom table fields, \nE.g the SQL statement:\n(
        USERID BIGINT,
        FIRST_NAME STRING,
        LAST_NAME STRING,
        NICKNAMES ARRAY(STRING),
        Gender BOOLEAN,
        ADDRESS STRUCT(
            STREET_NAME STRING,
            NUMBER BIGINT
        ),
    )`,
  },
  sqlRequired: {
    zh: '请输入 SQL',
    en: 'SQL is required',
  },
  dataSource: {
    zh: '数据源',
    en: 'Data Source',
  },
  confKey: {
    zh: '配置组',
    en: 'Configuration key',
  },
  format: {
    zh: '表格式',
    en: 'Table Format',
  },
  key: {
    zh: '主键',
    en: 'Key',
  },
  tableFields: {
    zh: '表字段',
    en: 'Table Fields',
  },
  sourceConfig: {
    zh: '源配置',
    en: 'Source Config',
  },
  fieldType: {
    zh: '字段类型',
    en: 'Field Type',
  },
  typeFirst: {
    zh: '请先选择表类型',
    en: 'Please select Table Type first',
  },
  addConfKey: {
    zh: '添加配置组',
    en: 'Add configuration key',
  },
  viewConfKey: {
    zh: '查看配置组',
    en: 'View configuration key',
  },
  addField: {
    zh: '添加表字段',
    en: 'Add table field',
  },
  arrayType: {
    zh: '数组类型',
    en: 'Array Type',
  },
  tableNameSpace: {
    zh: '表名称不能包含空格',
    en: 'Table Name can not contain space characters',
  },
  editConfKey: {
    zh: '编辑配置组',
    en: 'Edit configuration key',
  },
  retainSize: {
    zh: '保留大小',
    en: 'Retain size',
  },
  deleteTableWarning: {
    zh: '所有使用该表的规则将继续使用被删除的配置运行，直到重新启动，如果不正确，请手动停止它们。',
    en: 'All rules using this table will continue to run with the deleted configuration until restart, if it is not correct, please stop them manually.',
  },
}
